import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-not-found',
    standalone: true,
    templateUrl: './not-found.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent {
    private readonly router = inject(Router);

    constructor() {}
}
